// extracted by mini-css-extract-plugin
export default {"alertPanel":"alertPanel__JKbOTf","alert":"alert__CnNF2p","smallAlert":"smallAlert__HCFJr1","smallIcon":"smallIcon__W4OFKC","largeIcon":"largeIcon__XX8FzN"};